export const months = [
	{ name: "January", value: 1 },
	{ name: "February", value: 2 },
	{ name: "March", value: 3 },
	{ name: "April", value: 4 },
	{ name: "May", value: 5 },
	{ name: "June", value: 6 },
	{ name: "July", value: 7 },
	{ name: "August", value: 8 },
	{ name: "September", value: 9 },
	{ name: "October", value: 10 },
	{ name: "November", value: 11 },
	{ name: "December", value: 12 },
];

export const PciVendorTypes = [
	{ id: "0", name: "Other" },
	{ id: "1", name: "Rapid Comply" },
	{ id: "2", name: "Direct Sysnet" },
];

export const HighRiskType = [
	{ name: "Yes", id: true },
	{ name: "No", id: false },
];

export const getSelectedMonths = selectedMonths =>
	months.filter(({ value }) => selectedMonths?.includes(value));

export const getMonthName = value =>
	months.map(month => (value === month.value ? month.name : null));

export const getSelectedMonthForHookForm = monthNumber => {
	const monthsCorrected = months.map(({ name, value }) => ({
		displayName: name,
		name: value,
	}));
	return monthsCorrected.find(({ name }) => name === monthNumber);
};

export const getProcessorSponsorLabel = (
	processor: string,
	sponsor: string,
) => {
	let result = "";

	if (!processor && !sponsor) return;

	if (processor) {
		result += processor;
	}

	result += " / ";

	if (sponsor) {
		result += sponsor;
	}

	return result;
};

export const unassignedOption = {
	firstName: "Unassigned",
	lastName: "",
	id: "unassigned",
};
